module.exports = __webpack_public_path__ + "static/media/ic_dialog_success.2d89b82b.svg";